import React from 'react';
import { View, Text } from 'react-native';

const Carousel = () => {
  return (
    <View>
      <Text>Carousel Example</Text>
    </View>
  );
};

export default Carousel;
